module.exports = __webpack_public_path__ + "TRUONGabout-5.54e84b61.png";